import { render, staticRenderFns } from "./TaskTypeEditModal.vue?vue&type=template&id=83e585ac&"
import script from "./TaskTypeEditModal.vue?vue&type=script&lang=ts&"
export * from "./TaskTypeEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports